export default __webpack_public_path__ + "static/colibri-1-web-22e0f156d90e3853079b511a2ecf961f.pdf";